import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=7fdcd8dd&scoped=true"
import script from "./UserSelector.vue?vue&type=script&lang=js"
export * from "./UserSelector.vue?vue&type=script&lang=js"
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=7fdcd8dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdcd8dd",
  null
  
)

export default component.exports